import React, { useEffect } from 'react';

const useClickOutside = (
	ref: React.MutableRefObject<HTMLDivElement | null>,
	isRefVisible: boolean,
	callback: () => void
) => {
	useEffect(() => {
		function handleClickOutside(event) {
			if (!ref?.current || ref.current.contains(event.target) || !isRefVisible) {
				return;
			}

			// React 18 may synchronously unmount the clicked element before
			// this document-level handler runs. A detached target is not an outside click.
			if (!event.target.isConnected) {
				return;
			}

			callback();
		}

		if (isRefVisible) {
			document.addEventListener('mousedown', handleClickOutside);
		}
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ref, isRefVisible, callback]);
};

export default useClickOutside;
